import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward } from '@fortawesome/free-solid-svg-icons';
import Editable from './Editable';

export default function UTMGroupField({
  changeView,
  utmBatch,
  setUTMBatch,
  setShowTable,
  showTable
}) {
  const [newGroupName, setGroupName] = useState('');
  const inputRef = useRef();
  const copyUTMBatch = { ...utmBatch };
  const placeholderText = copyUTMBatch.group_name
    ? copyUTMBatch.group_name
    : 'Enter Group Name';

  const updateGroupName = () => {
    if (newGroupName === '') return;

    let updatedGroupName = { ...utmBatch };
    updatedGroupName.group_name = newGroupName;
    setUTMBatch(updatedGroupName);
  };

  const handleChange = (event) => setGroupName(event.target.value);

  useEffect(() => updateGroupName(), [newGroupName]);

  return (
    <div className="grid u--height-30">
      <div className="grid__col-lg-6">
        {showTable ? (
          <button
            className="btn btn--blue u--margin-bottom-15"
            onClick={() => changeView({})}
          >
            <div className="u--margin-left-15 u--display-flex u--align-items-center">
              <FontAwesomeIcon
                icon={faBackward}
                className="u--color-primary u--margin-right-10"
              />
              <span className="u--text-transform-lowercase">Back to List</span>
            </div>
          </button>
        ) : (
          <button
            className="btn btn--blue u--margin-bottom-15"
            style={{ opacity: '0.5' }}
          >
            <div className="u--margin-left-15 u--display-flex u--align-items-center">
              <FontAwesomeIcon
                icon={faBackward}
                className="u--color-primary u--margin-right-10"
              />
              <span className="u--text-transform-lowercase">Back to List</span>
            </div>
          </button>
        )}

        <div className=" utm__group-field-input form__field  form__field--error u--display-flex u--align-items-center u--justify-flex-start">
          <label className="form__label u--margin-left-15 u--font-size-xl u--width-40 u--margin-right-10 u--display-flex u--flex-direction-column u--margin-bottom-0">
            Group Name:
          </label>
          <Editable
            text={newGroupName}
            placeholder={placeholderText}
            type="input"
            childRef={inputRef}
            firstEdit={!copyUTMBatch.group_name}
            setShowTable={setShowTable}
          >
            <input
              value={newGroupName}
              ref={inputRef}
              type="text"
              className="form__input form__input--lg"
              placeholder="UTM Group Name"
              onChange={(event) => handleChange(event)}
            />
          </Editable>
        </div>
      </div>
    </div>
  );
}
